import { defineChain } from "viem";
import config from "../../config/config";

export const appChain = defineChain({
  id: config.chainId,
  name: config.chainName,
  nativeCurrency: {
    name: config.chainSymbolFull,
    symbol: config.chainSymbol,
    decimals: 18,
  },
  rpcUrls: {
    default: {
      http: [...config.providerList],
    },
  },
  blockExplorers: {
    default: {
      name: config.chainName,
      url: config.explorerUrl.replace(/\/$/, ""),
    },
  },
});
